import { createContext } from 'react';

import { StaticSchemasKey, WidgetStaticSchemas } from 'shared/common/widgets';

type AnyWidgetData = WidgetStaticSchemas[StaticSchemasKey];

/**
 * The widget's own Studio-derived form data (`staticContent.widgetsFormData[id]`), kept apart from the authored
 * content object the static schemas describe. `createContentObject` seeds it with exactly these two fields:
 * `errors` for every widget, `scoreWeight` only for widgets that can carry one (see `canHaveScoreWeight`).
 */
export type StaticWidgetFormData = {
  /** Studio validation errors by field; always present, empty when the widget is valid. Studio-side only. */
  errors?: Record<string, string[]>;
  /** The share of the activity grade Studio distributed to the widget; 0 for a question marked "ללא ציון" or hidden. */
  scoreWeight?: number;
};

export type StaticContentObjectContextType = {
  data: AnyWidgetData;
  /** Empty when Studio wrote no form data for the widget (non-scorable widgets, older documents). */
  formData: StaticWidgetFormData;
  id: string;
  columnSpan?: number;
  document: Record<string, unknown>;
};

export const StaticContentObjectContext = createContext<StaticContentObjectContextType | null>(null);
